import deepFreeze from '../client/utils/deepFreeze';
import imageSrc from '../common/image';

export const PRODUCT_MODEL_VIP = 'vip';
export const PRODUCT_MODEL_PACKAGE = 'package';

export const PAYMENT_STEPS = Object.freeze(['選擇付款方式', '填寫付款資訊', '付款結果']);

export const PAYMENT_ERROR_MESSAGE_DEFAULT = '您的付款似乎出現了一些問題，請重新嘗試。';
export const PAYMENT_ERROR_MESSAGE_WRONG_PROCESS = '流程有誤，請回到正確的路徑以進行購買。';

/** VIP 訂閱 */
export const SUBSCRIPTION_TYPE_VIP = 'SUBSCRIPTION_TYPE_VIP';

/** 主題訂閱 */
export const SUBSCRIPTION_TYPE_PACKAGE = 'SUBSCRIPTION_TYPE_PACKAGE';

export const PaymentProviderVip = Object.freeze({
  AppStore: 'AppStore',
  GooglePlay: 'GooglePlay',
  TopMso: 'TopMso',
  SonetTel: 'SonetTel',
  Spgateway: 'Spgateway',
  LinePay: 'LinePay',
  LineMobile: 'LineMobile',
  TapPay: 'TapPay',
  GiftShop: 'GiftShop',
  PromotionCode: 'PromotionCode',
});

export const PaymentProviderPackage = Object.freeze({
  TapPay: 'TAPPAY',
  LinePay: 'LINEPAY',
  AppStore: 'APPSTORE',
  GooglePlay: 'GOOGLEPLAY',
});

export const PAYMENT_PLATFORM_APP = 'app';
export const PAYMENT_PLATFORM_WEB = 'web';

export const PAYMENT_TYPE_IAP = 'IAP';

/**
 * @typedef {PAYMENT_PLATFORM_APP|PAYMENT_PLATFORM_WEB} PaymentPlatform
 *
 * @typedef {object} PaymentProviderInfo
 * @property {string} name
 * @property {PaymentPlatform} [platform]
 *
 * @typedef {} PaymentProviderInfoMap
 */

/**
 * @type {Readonly<Object.<string, PaymentProviderInfo>>}
 **/
export const PAYMENT_PROVIDER_INFO_MAP = deepFreeze({
  [PaymentProviderVip.AppStore]: {
    name: 'APP Store',
    platform: PAYMENT_PLATFORM_APP,
    type: PAYMENT_TYPE_IAP,
  },
  [PaymentProviderVip.GooglePlay]: {
    name: 'Google Play',
    platform: PAYMENT_PLATFORM_APP,
    type: PAYMENT_TYPE_IAP,
  },
  [PaymentProviderVip.TopMso]: {
    name: '台數科',
    platform: PAYMENT_PLATFORM_APP,
  },
  [PaymentProviderVip.SonetTel]: {
    name: 'So-Net 小額電信月租',
    platform: PAYMENT_PLATFORM_WEB,
  },
  [PaymentProviderVip.Spgateway]: {
    name: '智付通約定信用卡付款',
    platform: PAYMENT_PLATFORM_WEB,
  },
  [PaymentProviderVip.LinePay]: {
    name: 'LINE Pay',
    platform: PAYMENT_PLATFORM_WEB,
    image: `${imageSrc}/svg/line_pay_logo.svg`,
  },
  [PaymentProviderVip.LineMobile]: {
    name: 'LINE MOBILE',
    platform: PAYMENT_PLATFORM_WEB,
  },
  [PaymentProviderVip.TapPay]: {
    name: '信用卡',
    platform: PAYMENT_PLATFORM_WEB,
  },
  [PaymentProviderVip.GiftShop]: {
    name: '序號兌換',
  },
  [PaymentProviderVip.PromotionCode]: {
    name: '序號兌換',
    platform: PAYMENT_PLATFORM_WEB,
  },
  [PaymentProviderPackage.TapPay]: {
    name: '信用卡',
    platform: PAYMENT_PLATFORM_WEB,
  },
  [PaymentProviderPackage.LinePay]: {
    name: 'LINE Pay',
    platform: PAYMENT_PLATFORM_WEB,
  },
  [PaymentProviderPackage.AppStore]: {
    name: 'APP Store',
    platform: PAYMENT_PLATFORM_APP,
  },
  [PaymentProviderPackage.GooglePlay]: {
    name: 'Google Play',
    platform: PAYMENT_PLATFORM_APP,
  },
});

export const UNIFORM_INVOICE_DUPLICATE = 'UNIFORM_INVOICE_DUPLICATE'; // 二聯式發票
export const UNIFORM_INVOICE_TRIPLICATE = 'UNIFORM_INVOICE_TRIPLICATE'; // 三聯式發票

export const RedeemErrorCode = Object.freeze({
  /** 已有訂閱方案 */
  IsVip: 9001,
  /** 序號不存在 */
  VoucherNotFound: 9002,
  /** 序號已兌換 */
  VoucherRedeemed: 9003,
  /** 序號已過期 */
  VoucherExpired: 9004,
  /** 序號尚未開放兌換 */
  VoucherNotOpen: 9005,
  /** 序號已達兌換上限 */
  VoucherStockOut: 9006,
  /** 序號已兌換(同 9003 因後端序號兌換系統所以和 9003 分開) */
  VoucherRedeemedNew: 9007,
  /** 找不到可以兌換的方案 */
  NoProduct: Symbol("NoProduct"),
});
